import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";
import MultiSelect from "../PageComponents/RavenCustomSelect";

const multiSelectInvalidStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: "#f46a6a",
      paddingRight: "calc(1.5em + 0.94rem)",
      backgroundImage:
        "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f46a6a'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f46a6a' stroke='none'/%3e%3c/svg%3e\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right calc(0.375em + 0.235rem) center",
      backgroundSize: "calc(0.75em + 0.47rem) calc(0.75em + 0.47rem)",
    }),
  };
  
  const multiSelectDisableStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: "#eff2f7",
      opacity: 1,
      pointerEvents: "none",
    }),
  };

const RavenFormikMultiSelectComp = ({
  name,
  label,
  type,
  valueList,
  divClassName,
  getDescription,
  onChange,
  placeholder,
  defaultOption,
  errors,
  touched,
  disabled,
  handleMultiSelectOnChange
}) => {
  return (
    <div id={name + "_div"} className={divClassName || "mb-3"}>
      <Label className="form-label">{label}</Label>
      <div name={name} id={name} className="is-invalid">
        <Field
          name={name}
          isMulti={type !== "singleselect"}
          component={MultiSelect}
          defaultValue={defaultOption}
          options={valueList.map((item, idx) => ({
            label: getDescription(item),
            value: item.guid,
          }))}
          onChangeFunction={onChange !== undefined}
          placeholder={placeholder}
          {...(errors[name] &&
            touched[name]
              ? { multiSelectStyles: multiSelectInvalidStyles }
              : {})}
            {...(disabled
              ? { multiSelectStyles: multiSelectDisableStyles }
              : {})}
            {...(onChange
              ? { setOnChange: handleMultiSelectOnChange }
              : {})}
        />
      </div>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikMultiSelectComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  type: PropTypes.any,
  valueList: PropTypes.any,
  divClassName: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  getDescription: PropTypes.func,
  defaultOption: PropTypes.string,
  errors: PropTypes.any,
  touched: PropTypes.any,
  disabled: PropTypes.any,
  handleMultiSelectOnChange: PropTypes.any,
};

export default RavenFormikMultiSelectComp;
